import MoveManger from "../../../../gd/manager/move-manager"
import Meeting from "../../../../model2/meeting/meeting"
import ProjectSession from "../../../../model2/project/project-session"

type ModalMoveTo_commitParams = {
    meetingToMove         : Meeting
    targetProject   : ProjectSession
}

export default function ModalMoveTo_commitMeetingMoveToFolder(params: ModalMoveTo_commitParams, onMoveCallback?: {(selectedProjectId?: ID): void} ) {
    MoveManger.moveMeetingToProject(params.meetingToMove.id, params.targetProject.id, () => {
        onMoveCallback?.(params.targetProject.id)
        gd.modal.hide()
    })
}